class SideMenu {
  _state = {
    subOpen: false,
  };

  static options = {
    delay: 100,
    transition: 100,
  };

  constructor(element, options) {
    this._element = element;
    this._options = { ...SideMenu.options, ...options };
    this._cacheSelectors();

    this._menuLevels = {
      first_level_menu: 1,
      second_level_menu: 2,
      third_level_menu: 3,
      fourth_level_menu: 4,
    };

    this._initialize();
  }

  _cacheSelectors() {
    this._elements = {
      images: Array.from(this._element.querySelectorAll('.figure')),
      links: Array.from(this._element.querySelectorAll('#side-menu__navigation li')),
      navigationList: Array.from(this._element.querySelectorAll(`.side-menu .navigation-list`)),
      first_level_menu: this._element.querySelector(".navigation-list[data-level='1']"),
      second_level_menu: this._element.querySelector(".navigation-list[data-level='2']"),
      third_level_menu: this._element.querySelector(".navigation-list[data-level='3']"),
      fourth_level_menu: this._element.querySelector(".navigation-list[data-level='4']"),
      backButton: this._element.querySelector('.side-menu__back__button'),
      backButtonTitle: this._element.querySelector('#side-menu__active-title'),
      // ,
      // closeButtons: [...this._element.querySelectorAll('.close-sidemenu')]
    };
  }

  _initialize() {
    this._closeAllMenus();
    this._showMenu(this._elements.first_level_menu);

    // Close all menus when clicking on close
    // this._elements.closeButtons.forEach(el => {
    //   el.addEventListener('click', () => this._closeAllMenus())
    // })

    // Make each link clickable and search for submenu
    this._elements.links.forEach((el) => {
      el.addEventListener('click', (event) => this._clickedNavigationItem(event));
    });

    this._elements.backButton.addEventListener('click', () => this._clickedBackButton());

    this._switchImages();
  }

  /**
   * Close all of the menus
   */
  _closeAllMenus() {
    this._elements.navigationList.forEach((el) => {
      el.dataset.active = false;
    });
  }

  /**
   * when clicked on any <li> item in the menu
   * @param {*} event
   */
  // eslint-disable-next-line complexity
  _clickedNavigationItem(event) {
    event.stopPropagation();

    const clickedElement = event.currentTarget.closest('li');
    const nextMenu = clickedElement.querySelector('ul');
    const clickedElementLevel = parseInt(clickedElement.dataset.level, 10);

    // Switch images (only on the first level)
    if (clickedElementLevel === 1) {
      const innerLink = clickedElement.querySelector('.navigation-link');
      if (innerLink) {
        this._elements.backButtonTitle.dataset.previousTitle = innerLink.textContent;
      }

      this._switchImages(clickedElement);
    }

    // When menu is already active close the menu
    if (
      clickedElementLevel === this._menuLevels.first_level_menu &&
      nextMenu &&
      nextMenu.dataset.active === 'true'
    ) {
      this._closeAllMenus(nextMenu);
      this._showMenu(this._elements.first_level_menu);
      this._element.dataset.subOpen = false;
      return;
    } else if (
      clickedElementLevel === this._menuLevels.second_level_menu &&
      nextMenu &&
      nextMenu.dataset.active === 'true'
    ) {
      this._closeAllMenus(nextMenu);
      this._element.dataset.subOpen = true;
      this._element.dataset.showLevel = '2';
      this._element.querySelector("ul[data-level='2']").dataset.active = true;
      return;
    } else if (
      clickedElementLevel === this._menuLevels.third_level_menu &&
      nextMenu &&
      nextMenu.dataset.active === 'true'
    ) {
      this._closeAllMenus(nextMenu);
      this._element.dataset.subOpen = true;
      this._element.dataset.showLevel = '3';
      this._element.querySelector("ul[data-level='3']").dataset.active = true;
      return;
    }

    // Don't open an item that is already active
    if (nextMenu && nextMenu.dataset.active === 'true') {
      return;
    }

    // If menu has a submenu, open it
    if (nextMenu) {
      this._elements.backButtonTitle.textContent = clickedElement.dataset.title;

      this._closeAllMenus(nextMenu);
      this._showMenu(nextMenu);
    }
  }

  /**
   * Show menu based on either level or element
   * @param {*} element
   */
  _showMenu(element) {
    const menuLevel = parseInt(element.dataset.level, 10);

    if (menuLevel > 1) {
      this._state.subOpen = true;
      this._element.dataset.subOpen = true;
      this._elements.backButton.dataset.visible = true;
    } else {
      this._state.subOpen = false;
      this._element.dataset.subOpen = false;
      this._elements.backButton.dataset.visible = false;
    }

    if (menuLevel === this._menuLevels.third_level_menu) {
      element.closest("ul[data-level='2']").dataset.active = true;
    }

    if (menuLevel === this._menuLevels.fourth_level_menu) {
      element.closest("ul[data-level='3']").dataset.active = true;
      element.closest("ul[data-level='2']").dataset.active = true;
    }

    this._element.dataset.showLevel = menuLevel;

    const waitForMenu = 200;
    setTimeout(() => {
      element.dataset.active = true;
    }, waitForMenu);
  }

  /**
   * When the user clicks on the back button in the mobile menu
   */
  _clickedBackButton() {
    const currentShowLevel = parseInt(this._element.dataset.showLevel, 10) - 1;
    this._element.dataset.showLevel = currentShowLevel;

    this._closeAllMenus();

    if (currentShowLevel === this._menuLevels.second_level_menu) {
      this._showMenu(this._elements.second_level_menu);
      this._elements.backButtonTitle.textContent =
        this._elements.backButtonTitle.dataset.previousTitle;
    }

    if (currentShowLevel === this._menuLevels.third_level_menu) {
      this._showMenu(this._elements.third_level_menu);
    }

    if (currentShowLevel === this._menuLevels.fourth_level_menu) {
      this._showMenu(this._elements.fourth_level_menu);
    }

    if (currentShowLevel < this._menuLevels.second_level_menu) {
      this._showMenu(this._elements.first_level_menu);
    }
  }

  /**
   * Switch images on the side
   * @param {*} clickedElement
   */
  _switchImages(clickedElement) {
    let imageIndex = 0;

    if (clickedElement) {
      const el = clickedElement.querySelector('.menu-link');
      if (el) {
        imageIndex = el.getAttribute('data-image');
      }
    }

    this._elements.images.forEach((targ, i) => {
      if (i !== imageIndex) {
        targ.dataset.active = false;
      }
    });

    const image = this._elements.images[imageIndex];
    if (image) {
      image.dataset.active = true;
    }
  }
}

export default SideMenu;
